module.exports = require('./helpers/bundle-url').getBundleURL('1OwBs') + "demo.6e2dc86c.jpg" + "?" + Date.now();